<section class="application-details">
  <div class="application-details__container">
    <h1 *ngIf="isCreateMode" class="application-details__title title is-4">Create application</h1>
    <h1 *ngIf="!isCreateMode" class="application-details__title title is-4">Edit application</h1>

    <ng-container *ngIf="!isCreateMode">
      <p *ngIf="loading">Loading…</p>
      <p *ngIf="!loading && error">{{ error }}</p>
    </ng-container>

    <p *ngIf="saveError" class="save-error">{{ saveError }}</p>
    <p *ngIf="saveSuccess" class="save-success">{{ saveSuccess }}</p>

    <form
      *ngIf="isCreateMode || (!loading && !error)"
      class="application-form"
      (ngSubmit)="save()"
    >
      <div class="application-form__fields">
        <ng-container *ngIf="!isCreateMode">
          <label>
            Client ID
            <input type="text" class="readonly" [value]="readonlyClientId" readonly />
          </label>

          <label>
            Authentication key
            <input type="text" class="readonly" [value]="readonlyAuthenticationKey" readonly />
          </label>
        </ng-container>

        <label>
          Application name
          <input type="text" name="applicationName" [(ngModel)]="formModel.applicationName" />
        </label>

        <label class="checkbox">
          <input
            type="checkbox"
            name="IsActive"
            [(ngModel)]="formModel.IsActive"
            [disabled]="!isCreateMode"
          />
          Active
        </label>

        <label>
          Contact name
          <input type="text" name="ContactName" [(ngModel)]="formModel.ContactName" />
        </label>

        <label>
          Contact email
          <input type="email" name="ContactEmail" [(ngModel)]="formModel.ContactEmail" />
        </label>

        <label>
          Webhook URL
          <input type="url" name="WebhookUrl" [(ngModel)]="formModel.WebhookUrl" />
        </label>

        <label>
          Webhook authentication key
          <input
            type="text"
            name="WebhookAuthenticationKey"
            [(ngModel)]="formModel.WebhookAuthenticationKey"
          />
        </label>

        <label>
          Webhook authentication type
          <div class="select is-fullwidth">
            <select
              name="WebhookAuthenticationType"
              [(ngModel)]="formModel.WebhookAuthenticationType"
            >
              <option *ngFor="let authType of webhookAuthTypes" [ngValue]="authType">
                {{ authType }}
              </option>
            </select>
          </div>
        </label>
      </div>

      <div class="form-actions">
        <button
          *ngIf="!isCreateMode"
          type="button"
          class="button is-light"
          [disabled]="saving || statusSaving"
          (click)="toggleActive()"
        >
          {{ statusSaving ? 'Updating…' : (formModel.IsActive ? 'Make InActive' : 'Make Active') }}
        </button>

        <button type="submit" class="button is-primary" [disabled]="saving || statusSaving">
          {{ saving ? 'Saving…' : (isCreateMode ? 'Create' : 'Save') }}
        </button>
      </div>
    </form>

    <section
      *ngIf="!isCreateMode && !loading && !error"
      class="question-mappings"
    >
      <div class="question-mappings__header">
        <h3>Question mappings</h3>
        <div class="question-mappings__add">
          <button
            type="button"
            class="button is-primary is-small"
            (click)="openAddMappingModal()"
          >
            Add mapping
          </button>
        </div>
      </div>

      <p *ngIf="mappingActionError" class="question-mappings__error">{{ mappingActionError }}</p>

      <div *ngIf="mappingPopoverOpen" class="modal is-active question-mapping-modal">
        <div class="modal-background" (click)="closeMappingPopover()"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              {{ mappingModalMode === 'edit' ? 'Edit question mapping' : 'Add question mapping' }}
            </p>
            <button
              type="button"
              class="delete"
              aria-label="close"
              [disabled]="mappingSaving"
              (click)="closeMappingPopover()"
            ></button>
          </header>

          <section class="modal-card-body">
            <p *ngIf="mappingPopoverError" class="question-mapping-modal__error">
              {{ mappingPopoverError }}
            </p>

            <label>
              Filter questions
              <input
                type="text"
                name="questionFilter"
                class="input"
                placeholder="Filter questions"
                [value]="questionFilterText"
                (input)="onQuestionFilterChange($any($event.target).value)"
              />
            </label>

            <label>
              Question
              <busy-indicator [show]="loadingQuestions" [margins]="false">
                <div class="select is-fullwidth">
                  <select
                    name="selectedQuestion"
                    [(ngModel)]="selectedQuestionId"
                    (ngModelChange)="onSelectedQuestionChange($event)"
                    [disabled]="loadingQuestions"
                  >
                    <option [ngValue]="null">Choose a question…</option>
                    <option
                      *ngFor="let question of filteredConfirmatoryQuestions"
                      [ngValue]="question.id"
                    >
                      {{ question.question_name }}
                    </option>
                  </select>
                </div>
              </busy-indicator>
            </label>

            <div
              *ngIf="loadingQuestionCategories || questionHasCategories"
              class="question-mapping-modal__categories"
            >
              <busy-indicator [show]="loadingQuestionCategories" [margins]="false">
                <ng-container *ngIf="questionHasCategories">
                  <label class="checkbox question-mapping-modal__categories-checkbox">
                    <input
                      type="checkbox"
                      name="justSendCategories"
                      [(ngModel)]="justSendCategories"
                    />
                    Just send categories
                  </label>
                  <p class="question-mapping-modal__help">
                    If not checked both analytic data and categories will be sent
                  </p>
                </ng-container>
              </busy-indicator>
            </div>

            <label>
              Integration question ID
              <input
                type="text"
                name="integrationQuestionId"
                class="input"
                [(ngModel)]="integrationQuestionId"
              />
            </label>
          </section>

          <footer class="modal-card-foot">
            <button
              type="button"
              class="button is-light"
              [disabled]="mappingSaving"
              (click)="closeMappingPopover()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="button is-primary"
              [disabled]="mappingSaving || loadingQuestions"
              (click)="saveQuestionMapping()"
            >
              {{ mappingSaving ? 'Saving…' : (mappingModalMode === 'edit' ? 'Save' : 'Add') }}
            </button>
          </footer>
        </div>
      </div>

      <div *ngIf="questionMappings.length > 0" class="table-container">
        <table class="table is-fullwidth is-striped is-hoverable">
          <thead>
            <tr>
              <th>Question name</th>
              <th>Integration question ID</th>
              <th>Question ID</th>
              <th class="question-mappings__actions-header">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let mapping of questionMappings">
              <td>{{ mapping.question_name || '—' }}</td>
              <td>{{ mapping.integration_question_id || '—' }}</td>
              <td>{{ mapping.question_id || '—' }}</td>
              <td class="question-mappings__actions">
                <button
                  type="button"
                  class="button is-small is-light"
                  [disabled]="isMappingActionPending(mapping)"
                  (click)="openEditMappingModal(mapping)"
                >
                  Edit
                </button>
                <button
                  type="button"
                  class="button is-small is-danger is-light"
                  [disabled]="isMappingActionPending(mapping)"
                  (click)="deleteQuestionMapping(mapping)"
                >
                  {{ isDeletingMapping(mapping) ? 'Deleting…' : 'Delete' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <p *ngIf="questionMappings.length === 0" class="question-mappings__empty">
        No question mappings found.
      </p>
    </section>
  </div>
</section>
